module.exports = __webpack_public_path__ + "static/media/heat2.c48a9673.png";